import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../../store/auth";
import { Spinner } from "../ui/Spinner";

export const ProtectedRoute = () => {
  const status = useAuthStore((state) => state.status);
  const agent = useAuthStore((state) => state.agent);

  if (status === "idle" || status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950">
        <Spinner />
      </div>
    );
  }

  if (!agent) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
